import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/routeplan.png'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-column wp1200 justify-content-center align-items-center h-full gap-3 -mt-4 sm:flex-row sm:justify-content-start"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-6rem"
}, null, -1)
const _hoisted_3 = { class: "text-4xl font-semibold mt-2 sm:text-5xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'bg-primary-50 h-13rem': !_ctx.hasRouteQuery,
      'border-bottom-1 border-gray-300': _ctx.hasRouteQuery,
    })
  }, [
    (!_ctx.hasRouteQuery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("route_planner.title")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["wp1200", { '-mt-3 py-0': !_ctx.hasRouteQuery, 'py-3': _ctx.hasRouteQuery }])
    }, [
      _createVNode(_component_Toolbar)
    ], 2)
  ], 2))
}